import Konva from 'konva';

interface PositionPercentage {
  x: number; // 数值区间[-1, 1]
  y: number;
}

// 转换百分比到坐标
export const getAbsolutePosition = (
  bgSize: { width: number; height: number },
  percentX: number,
  percentY: number,
  width: number,
  height: number,
  scale: number,
): { x: number; y: number } => {
  const stageCenterX = bgSize.width / 2;
  const stageCenterY = bgSize.height / 2;
  const imgCenterX = stageCenterX + percentX * stageCenterX;
  const imgCenterY = stageCenterY - percentY * stageCenterY;
  const x = imgCenterX - (width * scale) / 2;
  const y = imgCenterY - (height * scale) / 2;

  return { x, y };
};

// 转换坐标到百分比
export const getPositionPercentage = (
  bgSize: { width: number; height: number },
  node: Konva.Image,
): PositionPercentage => {
  const imgCenterX = node.x() + node.width() * node.scaleX() / 2;
  const imgCenterY = node.y() + node.height() * node.scaleY() / 2;
  const stageCenterX = bgSize.width / 2;
  const stageCenterY = bgSize.height / 2;
  const x = (imgCenterX - stageCenterX) / stageCenterX;
  const y = (stageCenterY - imgCenterY) / stageCenterY;

  return { x, y };
};
